import { DateTimeInput, DateTimeInputProps } from "@react-admin/ra-form-layout";

const CustomDateTimeInput = (props: DateTimeInputProps) => {
  return (
    <DateTimeInput
      parse={(value) => {
        if (!value) return null;
        const date = new Date(value);
        return isNaN(date.getTime()) ? value : date.toISOString();
      }}
      ampm={false}
      mask="dd/MM/yyyy HH:mm"
      {...props}
    />
  );
};

export default CustomDateTimeInput;
